import {useState} from "react";
import {useNavigate} from "react-router-dom";
import api from "../api/axiosInstance";
import {login} from "../components/slices/authSlices";
import {Button} from '../components/Button';
import {useDispatch} from "react-redux";

export default function LoginPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const res = await api.post("/auth/login", {username, password}, {withCredentials: true});
            if (res.status === 200) {
                dispatch(login({token: "dummy-token", user: "dummy-user"}));
                navigate("/");
            } else {
                setError("Login failed");
            }
        } catch (err) {
            console.log(err);
            setError("Login failed");
        }
    };

    return (
        <div className="max-w-md mx-auto p-6 border rounded mt-20">
            <h1 className="text-2xl font-bold mb-4">Login</h1>
            {error && <p className="text-red-600 mb-4">{error}</p>}
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <input
                    type="text"
                    placeholder="Email"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    className="border p-2 rounded"
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="border p-2 rounded"
                />
                <Button variant="solid">Login</Button>
            </form>
        </div>
    );
}
